"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigHeader = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 12px 12px 8px 12px;
  .header-title {
    flex: 1;
  }
`;
const ConfigHeader = (_a) => {
    var { className, end, children } = _a, props = __rest(_a, ["className", "end", "children"]);
    return (react_1.default.createElement(StyledDiv, Object.assign({ className: `config-header${className ? ` ${className}` : ''}` }, props),
        react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'header-title' }, children),
        end));
};
exports.ConfigHeader = ConfigHeader;
exports.default = exports.ConfigHeader;
//# sourceMappingURL=ConfigHeader.js.map